import React from 'react'
import ReactDom from 'react-dom'
import THREE from 'particlespace-graphics-engine'

import { buildingRenderer } from '../../core/graphic_engine/controllers/building.js'

export default class CanvasComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            updateCanvas: false,
            renderer: null,
            domID: this.props.domID,
            classID: this.props.classID
        }
    }
    componentDidUpdate() {
        if(this.state.updateCanvas) {
            jQuery(ReactDom.findDOMNode(this.refs.buildingCanvas)).html("");
            ReactDom.findDOMNode(this.refs.buildingCanvas).appendChild(this.state.renderer.domElement);
            this.state.updateCanvas = false;
        }
    }
    componentWillUpdate(nextProps, nextState) {
        this.state.updateCanvas = nextProps.updateCanvas;
        this.state.renderer = nextProps.renderer;
    }
    render() {
        return (
            <div ref="buildingCanvas" id={this.state.domID} class={this.state.classID}>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// app/components/Graphics/CanvasComponent.jsx